import { render } from "./TourDeleteConfirmationModal.vue?vue&type=template&id=5065e6d4"
import script from "./TourDeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./TourDeleteConfirmationModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5065e6d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5065e6d4', script)) {
    api.reload('5065e6d4', script)
  }
  
  module.hot.accept("./TourDeleteConfirmationModal.vue?vue&type=template&id=5065e6d4", () => {
    api.rerender('5065e6d4', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/TourDeleteConfirmationModal.vue"

export default script